import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import {
  BarcodeExportConfiguration,
  BarcodeExportConfigurationEntityType,
  BarcodeExportConfigurationEntry,
} from './barcodeExportConfiguration';

export class BarcodeExportConfigurationInput
  extends BarcodeExportConfiguration
  implements EntityInput<BarcodeExportConfiguration>
{
  forCreate(): CreateBarcodeExportConfigurationInput {
    return CreateBarcodeExportConfigurationInput.from(this, CreateBarcodeExportConfigurationInput);
  }

  forUpdate(): UpdateBarcodeExportConfigurationInput {
    return UpdateBarcodeExportConfigurationInput.from(this, UpdateBarcodeExportConfigurationInput);
  }

  forDelete(): DeleteBarcodeExportConfigurationInput {
    return DeleteBarcodeExportConfigurationInput.from(this, DeleteBarcodeExportConfigurationInput);
  }

  validate(): boolean {
    if (!this.name || !this.name.trim()) return false;
    if (!this.entries.length) return false;
    if (!this.entityType) return false;

    return true;
  }

  hasChanges(original: BarcodeExportConfiguration | undefined): boolean {
    if (!original) return true;

    if (this.name !== original.name) return true;
    if (this.entries !== original.entries) return true;

    return false;
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withEntityType(entityType: BarcodeExportConfigurationEntityType) {
    this.entityType = entityType;
    return cloneDeep(this);
  }

  withEntries(entries: BarcodeExportConfigurationEntry[]) {
    this.entries = entries;
    return cloneDeep(this);
  }
}

export class CreateBarcodeExportConfigurationInput extends forCreate(BarcodeExportConfiguration) {}

export class UpdateBarcodeExportConfigurationInput extends forUpdate(BarcodeExportConfiguration) {}

export class DeleteBarcodeExportConfigurationInput extends forDelete(BarcodeExportConfiguration) {}
